import React, { useState } from 'react';

import DataGridFooter from 'src/components/DataGrid/DataGridFooter';
import Pagination from 'src/components/Pagination/Pagination';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import s from './JobSurveyFalsification.styles';
import { JobSurveyStatusPopup } from './JobSurveyStatusPopup';
import { AutoResponseTypeOptions, ManualOverrideOptions } from './constants';

momentDurationFormatSetup(moment);

const JobSurveyResponses = props => {
  const {
    jobSurveyResponsesData,
    surveyResponsesRefetch,
    dataFalsificationRulesName,
    surveyDatasheet,
  } = props;

  const [showStatusChangePopup, setShowStatusChangePopup] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [selectedOverrideOption, setSelectedOverrideOption] = useState(null);

  const formatString = 'DD-MMM-YYYY HH:mm:ss z';

  const closeStatusConfirmPopup = () => {
    setShowStatusChangePopup(false);
    setSelectedResponse(null);
    setSelectedOverrideOption(null);
  };

  const onSubmitStatusChange = () => {
    closeStatusConfirmPopup();
    surveyResponsesRefetch();
  };

  const getSurveyResponseRulesAppliedValue = (
    responseType,
    invalidFalsificationRule,
  ) => {
    if (responseType === 'MANUAL_VALID') {
      return 'Valid (Manual Override)';
    }
    if (responseType === 'MANUAL_INVALID') {
      return 'Invalid (Manual Override)';
    }
    return invalidFalsificationRule;
  };

  const questions =
    surveyDatasheet?.currentVersion?.survey?.surveyData?.questions || [];
  const jobSurveyResponsesDataGrid = jobSurveyResponsesData?.surveyResponses.map(
    surveyResponse => {
      const surveyResponseBasic = {
        id: surveyResponse.id,
        '#': surveyResponse.responseNumber,
        'Start Time': surveyResponse.startedAt
          ? moment(surveyResponse.startedAt).format(formatString)
          : '',
        'End Time': surveyResponse.finishedAt
          ? moment(surveyResponse.finishedAt).format(formatString)
          : '',
        Duration: surveyResponse.responseTime
          ? moment
              .duration(surveyResponse.responseTime, 'seconds')
              .format('h[h] m[m] s[s]')
          : '',
        Status: surveyResponse.responseType,
        'Rules Applied': getSurveyResponseRulesAppliedValue(
          surveyResponse.responseType,
          surveyResponse.invalidFalsificationRules,
        ),
      };

      const surveyResponseQuestion = Object.assign(
        {},
        ...questions.map(question => {
          const resultNumber = (surveyResponse.results || []).find(
            result =>
              result.datasheetQuestionId === question.datasheetQuestionId,
          )?.resultNumber;

          return {
            [`Q${question.questionNumber}`]: Array.isArray(resultNumber)
              ? [...resultNumber].sort((a, b) => a - b).join(', ')
              : resultNumber,
          };
        }),
      );
      return { ...surveyResponseBasic, ...surveyResponseQuestion };
    },
  ); 
  const rulesAppliedLabel = (value) =>{
    let label = dataFalsificationRulesName[value];
    if(Array.isArray(value)){
      label = value.map(i => dataFalsificationRulesName[i]).join(', ');
    }
    return label;
  }
  return (
    <>
      <s.TableRow>
        {jobSurveyResponsesDataGrid &&
          Object.keys(jobSurveyResponsesDataGrid[0])
            .filter(key => key !== 'id')
            .map((key, colIndex) => {
              return (
                <s.Column key={colIndex} header>
                  {key}
                </s.Column>
              );
            })}
      </s.TableRow>
      {jobSurveyResponsesDataGrid &&
        jobSurveyResponsesDataGrid.map((response, resIndex) => {
          return (
            <s.TableRow key={resIndex}>
              {jobSurveyResponsesDataGrid &&
                Object.keys(jobSurveyResponsesDataGrid[0])
                  .filter(key => key !== 'id')
                  .map(key => {
                    if (key === 'Status') {
                      return (
                        <s.Column key={key} content>
                          <s.StatusSelectBox
                            disabled={!response['End Time']}
                            onChange={option => {
                              setSelectedResponse({
                                ...jobSurveyResponsesData?.surveyResponses?.find(
                                  sr => sr.id === response.id,
                                ),
                              });
                              setSelectedOverrideOption(option);
                              setShowStatusChangePopup(true);
                            }}
                            options={ManualOverrideOptions}
                            pageStyle
                            value={
                              ManualOverrideOptions.find(
                                c => c.value === response[key],
                              ) ||
                              AutoResponseTypeOptions.find(
                                c => c.value === response[key],
                              )
                            }
                          />
                        </s.Column>
                      );
                    }
                    return (
                      <s.Column
                        key={key}
                        content
                      >
                        {
                          key === 'Rules Applied' ? 
                          rulesAppliedLabel(response[key]) : 
                          response[key] 
                        }
                      </s.Column>
                    );
                  })}
            </s.TableRow>
          );
        })}
      {jobSurveyResponsesData &&
        jobSurveyResponsesData.surveyResponsesPageInfo && (
          <DataGridFooter>
            <Pagination
              pageNeighbours={1}
              refetch={surveyResponsesRefetch}
              totalRecords={
                jobSurveyResponsesData.surveyResponsesPageInfo.totalCount
              }
              useQuery={true}
              key={surveyDatasheet.id}
            />
          </DataGridFooter>
        )}
      {showStatusChangePopup && (
        <JobSurveyStatusPopup
          onClose={closeStatusConfirmPopup}
          onSubmit={onSubmitStatusChange}
          response={selectedResponse}
          selectedOverrideOption={selectedOverrideOption}
        />
      )}
    </>
  );
};

export default React.memo(JobSurveyResponses);
